// import { useEffect, useState } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { fetchState, createTerritory } from "../../../api/locationApi"; // ⬅️ use createTerritory
// import { toast } from "react-toastify";
// import {
//   Box,
//   Button,
//   CircularProgress,
//   MenuItem,
//   Select,
//   TextField,
//   Typography,
//   InputLabel,
//   FormControl,
//   Paper,
// } from "@mui/material";

// export default function TerritoryForm() {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const editData = location.state?.territory || null;

//   const [stateList, setStateList] = useState([]);
//   const [form, setForm] = useState({
//     territory_state: "",
//     territory_name: "",
//   });
//   const [loading, setLoading] = useState(false);

//   const isEditMode = !!editData;

//   // Load states on mount
//   useEffect(() => {
//     async function loadStates() {
//       try {
//         const res = await fetchState();
//         setStateList(res || []);
//       } catch (err) {
//         console.error("Error loading states:", err);
//         toast.error("Failed to load states");
//       }
//     }
//     loadStates();
//   }, []);

//   // Prefill form after states load
//   useEffect(() => {
//     if (isEditMode && stateList.length > 0) {
//       const matchedState = stateList.find(
//         (s) =>
//           s.description?.toLowerCase() === editData.state?.toLowerCase() ||
//           s.description?.toLowerCase() === editData.territory_state?.toLowerCase()
//       );

//       setForm({
//         territory_state: matchedState
//           ? matchedState.description
//           : editData.state || editData.territory_state || "",
//         territory_name: editData.territory_name || editData.name || "",
//         tr_id: editData.tr_id || "",
//       });
//     }
//   }, [editData, stateList, isEditMode]);

//   // Handle input change
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setForm((prev) => ({ ...prev, [name]: value }));
//   };

//   // Submit handler
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!form.territory_state || !form.territory_name) {
//       toast.warning("Please fill all fields");
//       return;
//     }

//     setLoading(true);
//     try {
//       const payload = {
//         territory_state: form.territory_state,
//         territory_name: form.territory_name,
//       };

//       if (isEditMode && form.tr_id) {
//         payload.tr_id = form.tr_id;
//       }

//       const res = await createTerritory(payload); // ⬅️ API for territory
//       console.log("Territory API Response:", res);

//       if (res?.status === "success" || res?.success) {
//         toast.success(
//           isEditMode
//             ? "Territory updated successfully"
//             : "Territory created successfully"
//         );
//         navigate("/territory-master");
//       } else {
//         toast.error(res?.message || "Operation failed");
//       }
//     } catch (err) {
//       console.error("Error creating/updating territory:", err);
//       toast.error("Error processing request");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Box sx={{ p: 3 }}>
//       <Typography variant="h5" gutterBottom>
//         {isEditMode ? "Edit Territory" : "Add New Territory"}
//       </Typography>

//       <Paper
//         sx={{
//           p: 3,
//           borderRadius: 2,
//           boxShadow: 2,
//           backgroundColor: "#fafafa",
//           maxWidth: 500,
//         }}
//       >
//         <form onSubmit={handleSubmit}>
//           {/* State Dropdown */}
//           <FormControl fullWidth sx={{ mb: 3 }}>
//             <InputLabel id="state-label">Select State</InputLabel>
//             <Select
//               labelId="state-label"
//               name="territory_state"
//               value={form.territory_state}
//               onChange={handleChange}
//               label="Select State"
//             >
//               <MenuItem value="">
//                 <em>-- Select State --</em>
//               </MenuItem>
//               {stateList.map((s) => (
//                 <MenuItem key={s.code} value={s.description}>
//                   {s.description}
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>

//           {/* Territory Name */}
//           <TextField
//             fullWidth
//             label="Territory Name"
//             name="territory_name"
//             value={form.territory_name}
//             onChange={handleChange}
//             placeholder="Enter Territory Name"
//             variant="outlined"
//             sx={{ mb: 3 }}
//           />

//           {/* Buttons */}
//           <Box sx={{ display: "flex", gap: 2 }}>
//             <Button
//               type="submit"
//               variant="contained"
//               color="primary"
//               disabled={loading}
//               startIcon={loading && <CircularProgress size={18} />}
//             >
//               {loading
//                 ? "Saving..."
//                 : isEditMode
//                 ? "Update"
//                 : "Submit"}
//             </Button>

//             <Button
//               variant="outlined"
//               color="secondary"
//               onClick={() => navigate("/territory-master")}
//             >
//               Cancel
//             </Button>
//           </Box>
//         </form>
//       </Paper>
//     </Box>
//   );
// }





import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchState, createTerritory } from "../../../api/locationApi";
import { toast } from "react-toastify";
import {
  Box,
  Button,
  CircularProgress,
  MenuItem,
  Select,
  TextField,
  Typography,
  InputLabel,
  FormControl,
  Paper,
} from "@mui/material";

export default function TerritoryForm() {
  const navigate = useNavigate();
  const [stateList, setStateList] = useState([]);
  const [form, setForm] = useState({
    territory_state: "",
    territory_name: "",
  });
  const [loading, setLoading] = useState(false);

  // Load states
  useEffect(() => {
    async function loadStates() {
      try {
        const res = await fetchState();
        setStateList(res || []);
      } catch (err) {
        console.error("Error loading states:", err);
        toast.error("Failed to load states");
      }
    }
    loadStates();
  }, []);

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  // Submit handler
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.territory_state || !form.territory_name) {
      toast.warning("Please fill all fields");
      return;
    }

    setLoading(true);
    try {
      const payload = {
        territory_state: form.territory_state,
        territory_name: form.territory_name,
      };

      const res = await createTerritory(payload);
      console.log("Territory API Response:", res);

      if (res?.status === "success" || res?.success) {
        toast.success("Territory created successfully");
        navigate("/territory-master");
      } else {
        toast.error(res?.message || "Failed to create territory");
      }
    } catch (err) {
      console.error("Error creating territory:", err);
      toast.error("Error processing request");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" gutterBottom>
        Add New Territory
      </Typography>

      <Paper
        sx={{
          p: 3,
          borderRadius: 2,
          boxShadow: 2,
          backgroundColor: "#fafafa",
          maxWidth: 500,
        }}
      >
        <form onSubmit={handleSubmit}>
          {/* State Dropdown */}
          <FormControl fullWidth sx={{ mb: 3 }}>
            <InputLabel id="state-label">Select State</InputLabel>
            <Select
              labelId="state-label"
              name="territory_state"
              value={form.territory_state}
              onChange={handleChange}
              label="Select State"
            >
              <MenuItem value="">
                <em>-- Select State --</em>
              </MenuItem>
              {stateList.map((s) => (
                <MenuItem key={s.code} value={s.description}>
                  {s.description}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {/* Territory Name */}
          <TextField
            fullWidth
            label="Territory Name"
            name="territory_name"
            value={form.territory_name}
            onChange={handleChange}
            placeholder="Enter Territory Name"
            variant="outlined"
            sx={{ mb: 3 }}
          />

          {/* Buttons */}
          <Box sx={{ display: "flex", gap: 2 }}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              disabled={loading}
              startIcon={loading && <CircularProgress size={18} />}
            >
              {loading ? "Saving..." : "Submit"}
            </Button>

            <Button
              variant="outlined"
              color="secondary"
              onClick={() => navigate("/territory-master")}
            >
              Cancel
            </Button>
          </Box>
        </form>
      </Paper>
    </Box>
  );
}
